import ScrollSync from './ScrollSync';

export default ScrollSync;
export { ScrollSync };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-virtualized/dist/es/ScrollSync/index.js
// module id = 653
// module chunks = 0